export default __webpack_public_path__ + "static/media/CapaDelete.45c8da37.svg";